if(!customElements.get('product-registration')) {

  class ProductRegistration extends HTMLElement {
  	
    constructor() {
      super();
      this.querySelector('form#step_1_form').addEventListener('submit', this.step_1.bind(this));
      this.querySelector('form#step_2_form').addEventListener('submit', this.step_2.bind(this));
      this.querySelector('form#step_3_form').addEventListener('submit', this.step_3.bind(this));
      this.querySelector('#file_input').addEventListener('change', this.upload_images.bind(this));
      this.querySelector('#no_thanks').addEventListener('click', this.no_thanks.bind(this));
    }

    step_1(e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      var self = this;
      var form = self.querySelector('form#step_1_form');
      var error = false;
      var errorMsg = form.querySelector('.error-msg');
      var msg = '';
      var requiredFields = [];
 
      form.querySelector('button[type=submit]').setAttribute('disabled', '');

      errorMsg.style.display = 'none';
      form.querySelectorAll('.error').forEach((elem)=>{
        elem.classList.remove('error');
      });
      form.querySelectorAll('.required').forEach((elem)=>{
        if(elem.value=="" || (elem.type=='radio' && !form.querySelector('input[name="'+elem.name+'"]:checked')) || (elem.type=='checkbox' && !elem.checked) ) {
          error = true;
          elem.classList.add('error');
          if (elem.ariaLabel) {
            requiredFields.push(elem.ariaLabel);
          } else if (elem.placeholder) {
            requiredFields.push(elem.placeholder);
          } else if (elem.labels && elem.labels.length > 0) {
            requiredFields.push(elem.labels[0].innerText);
          }
        }
      });
      if (requiredFields.length==1) {
        msg = lngg.general__forms__complete_the_field_message.replace(new RegExp(/{{ *field *}}/), requiredFields[0]);
      }
      if(error) {
        errorMsg.innerHTML = msg || lngg.general__forms__complete_all_the_fields_message;
        errorMsg.style.display = 'block';
      } else {
        if(!$s.validateEmail(form.querySelector('.email').value)) {
          error = true;
          form.querySelector('.email').classList.add('error');
          errorMsg.style.display = 'block';
          errorMsg.innerHTML = lngg.general__forms__enter_a_valid_email_message;
        }
      }
      if(!error) {
        fetch("https://arcade1up.com/apps/whol/api/save", {
          method: "POST",
          headers: { "Content-type": "application/json" },
          body: JSON.stringify({
            domain: "arcade-1up.myshopify.com",
            first_name: form.querySelector('#first_name').value,
            last_name: form.querySelector('#last_name').value,
            email: form.querySelector('#email').value,
            product: form.querySelector('#product').value,
            product_size: '',
            product_color: '',
            is_subscribed: form.querySelector('#is_subscribed:checked') ? form.querySelector('#is_subscribed:checked').value : '',
            black_box: form.querySelector('#black_box').value,
            ip_address: form.querySelector('#ip_address').value
          })
        })
        .then(response => response.json())
        .then(data => {
          if(data.status == '1'){
            form.style.display = "none";
            document.querySelector("#step_2_form").style.display = "block";
            document.querySelector('#review_product').value = data.product;
            document.querySelector('#review_customer').value = data.customer;
            document.querySelector('.review_registration').value = data.registration;           
          } else {
            errorMsg.innerHTML = "An error occurred, please try again later.";
            errorMsg.style.display = "block";
          }
          form.querySelector('button[type=submit]').removeAttribute('disabled');
        })
        .catch(error => console.error(error));        
      }     
    }

    step_2(e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      var self = this;
      var form = self.querySelector('form#step_2_form');
      var error = false;
      var errorMsg = form.querySelector('.error-msg');
      var msg = '';
      var requiredFields = [];
     
      errorMsg.style.display = 'none';
      form.querySelectorAll('.error').forEach((elem)=>{
        elem.classList.remove('error');
      });
      form.querySelectorAll('.required').forEach((elem)=>{
        if(elem.value=="" || (elem.type=='radio' && !form.querySelector('input[name="'+elem.name+'"]:checked')) || (elem.type=='checkbox' && !elem.checked) ) {
          error = true;
          elem.classList.add('error');
          if (elem.ariaLabel) {
            requiredFields.push(elem.ariaLabel);
          } else if (elem.placeholder) {
            requiredFields.push(elem.placeholder);
          } else if (elem.labels && elem.labels.length > 0) {
            requiredFields.push(elem.labels[0].innerText);
          }
        }
      });
      if (requiredFields.length==1) {
        msg = lngg.general__forms__complete_the_field_message.replace(new RegExp(/{{ *field *}}/), requiredFields[0]);
      }
      if(error) {
        errorMsg.innerHTML = msg || lngg.general__forms__complete_all_the_fields_message;
        errorMsg.style.display = 'block';
      } else {        
        fetch("https://arcade1up.com/apps/whol/api/review", {
          method: "POST",
          headers: { "Content-type": "application/json" },
          body: JSON.stringify({
            domain: "arcade-1up.myshopify.com",
            registration: document.querySelector('.review_registration').value,
            customer: document.querySelector('#review_customer').value,
            product: document.querySelector('#review_product').value,
            stars: document.querySelector('#review_stars').value,
            title: document.querySelector('#review_title').value,
            description: document.querySelector('#review_description').value,            
            black_box: document.querySelector('#black_box').value,
            ip_address: document.querySelector('#ip_address').value,
            access_token: document.querySelector('#access_token').value,
          })
        })
        .then(response => response.json())
        .then(data => {
          if(data.status == '1'){
            form.style.display = "none";
            document.querySelector("#step_3_form").style.display = "block";
            window.scrollTo({ top: document.querySelector('product-registration').offsetTop, behavior: 'smooth'});
          } else {
            errorMsg.innerHTML = "An error occurred, please try again later.";
            errorMsg.style.display = "block";
          }
        })
      }
    }

    no_thanks(e){
      document.querySelector("#step_2_form").style.display = "none";
      document.querySelector("#step_3_form").style.display = "block";
      window.scrollTo({ top: document.querySelector('product-registration').offsetTop, behavior: 'smooth'});
    }
    
    step_3(e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      var self = this;
      var form = self.querySelector('form#step_3_form');
      var error = false;
      var errorMsg = form.querySelector('.error-msg');
      var msg = '';
      var requiredFields = [];
     
      form.querySelector('button[type=submit]').setAttribute('disabled', '');

      errorMsg.style.display = 'none';
      form.querySelectorAll('.error').forEach((elem)=>{
        elem.classList.remove('error');
      });
      form.querySelectorAll('.required').forEach((elem)=>{
        if(elem.value=="" || (elem.type=='radio' && !form.querySelector('input[name="'+elem.name+'"]:checked')) || (elem.type=='checkbox' && !elem.checked) ) {
          error = true;
          elem.classList.add('error');
          if (elem.ariaLabel) {
            requiredFields.push(elem.ariaLabel);
          } else if (elem.placeholder) {
            requiredFields.push(elem.placeholder);
          } else if (elem.labels && elem.labels.length > 0) {
            requiredFields.push(elem.labels[0].innerText);
          }
        }
      });
      if (requiredFields.length==1) {
        msg = lngg.general__forms__complete_the_field_message.replace(new RegExp(/{{ *field *}}/), requiredFields[0]);
      }
      if(error) {
        errorMsg.innerHTML = msg || lngg.general__forms__complete_all_the_fields_message;
        errorMsg.style.display = 'block';
      } else {        
        fetch("https://arcade1up.com/apps/whol/api/final-step", {
          method: "POST",
          headers: { "Content-type": "application/json" },
          body: JSON.stringify({
            domain: "arcade-1up.myshopify.com",
            registration: document.querySelector('.review_registration').value,
            serial_number: document.querySelector('#serial_number').value,
            purchase_date: document.querySelector('#purchase_date').value,
            purchase_location: document.querySelector('#purchase_location').value
          })
        })
        .then(response => response.json())
        .then(data => {
          if(data.status == '1'){
            form.style.display = "none";
            document.querySelector("#thank_you").style.display = "block";
          } else {
            errorMsg.innerHTML = "An error occurred, please try again later.";
            errorMsg.style.display = "block";
          }
          form.querySelector('button[type=submit]').removeAttribute('disabled');
        })
      }
    }

    upload_images(){
      document.querySelector('#step_2_form button[type=submit]').setAttribute('disabled', '');
      let fdata = new FormData();
      var dvlp_upload_files = document.querySelector('#file_input').files;   
      dvlp_upload_files.forEach(function(currentValue, index){
        fdata.append("file[" + index + "]", currentValue);
      });
      fdata.append("domain", "arcade-1up.myshopify.com");
      fdata.append("access_token", document.querySelector('#access_token').value);
      fetch("https://arcade1up.com/apps/whol/review-uploads", {
        method: "POST",
        data: fdata,
        body: fdata
      })
      .then(response => response.json())
      .then(data => {
        document.querySelector('#step_2_form button[type=submit]').removeAttribute('disabled');
      });
    }

  }

  customElements.define('product-registration', ProductRegistration);
}